<h2 mat-dialog-title>Edit content</h2>

<form [formGroup]="form">
  <div>
      <p>Zones to show</p>
      <app-chips
        [label]="'Zones'"
        [form]="form.get('zones')"
        [options]="rowOptions"
        [displayField]="'name'"
        (optionChange)="onSelectZone($event)"
      ></app-chips>
    </div>

  <div *ngIf="canEditHeading" class="field">
    <mat-form-field
      class="full-width"
      appearance="outline"
      floatLabel="always">
      <mat-label>Heading</mat-label>
      <input
        matInput
        placeholder="Heading"
        formControlName="heading"
      />
    </mat-form-field>
  </div>
</form>

<mat-dialog-content>
  <ng-container *ngIf="canEditContent; else contentNotEditable">
    <app-text-editor
      [id]="id"
      [type]="PREVIEW_PDF"
      [content]="textFromEditor"
      [width]="data.editor.width"
      [height]="data.editor.height">
    </app-text-editor>
  </ng-container>

  <ng-template #contentNotEditable>&nbsp;</ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button 
    mat-raised-button 
    color="primary"
    (click)="onUpdate()">
    Update
  </button>
</mat-dialog-actions>